<script setup lang="ts">
import type { AssociatedDeviceModel } from '@/types/models/DeviceModel'
import { DeviceSelector } from '@rfc/rfc-components-library'
import { ref, watch } from 'vue'

type Props = {
    associates: AssociatedDeviceModel[]
}
const props = defineProps<Props>()
const emit = defineEmits<{
    (e: 'refresh'): void
    (e: 'select', device: AssociatedDeviceModel): void
}>()

const device = ref()
watch(
    () => props.associates,
    () => (device.value = undefined)
)

const handleSelect = (value: AssociatedDeviceModel) => {
    device.value = value
    emit('select', value)
}
</script>

<template>
    <DeviceSelector
        :label="$t('device.filters.name')"
        :deviceId="device?.id"
        @select="handleSelect"
        labelKey="name"
        valueKey="id" />
</template>
